// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

var nbsp = String.fromCharCode(160);

var circleChar = String.fromCharCode(9679);

function currTimeStr(param) {
  return new Date(Date.now()).toISOString();
}

function compareDates(a, b) {
  var t1 = a.getTime();
  var t2 = b.getTime();
  if (t1 < t2) {
    return -1;
  } else if (t2 < t1) {
    return 1;
  } else {
    return 0;
  }
}

function floatToPctStr(pct) {
  return String(Math.round(pct * 100) | 0) + "%";
}

function cacheMake(recalc, depVerEq) {
  return {
          recalc: recalc,
          depVerEq: depVerEq,
          depVer: undefined,
          data: undefined
        };
}

function cacheGetByDepVer(cache, depVer) {
  var cachedDepVer = cache.depVer;
  if (cachedDepVer !== undefined && Curry._2(cache.depVerEq, Caml_option.valFromOption(cachedDepVer), depVer)) {
    return cache.data;
  }
  
}

function cacheGet(cache, depVer, dep) {
  var data = cacheGetByDepVer(cache, depVer);
  if (data !== undefined) {
    return Caml_option.valFromOption(data);
  }
  cache.depVer = Caml_option.some(depVer);
  var data$1 = Curry._1(cache.recalc, dep);
  cache.data = Caml_option.some(data$1);
  return data$1;
}

function strToRegex(str) {
  try {
    return {
            TAG: /* Ok */0,
            _0: new RegExp(str)
          };
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    return {
            TAG: /* Error */1,
            _0: Belt_Option.getWithDefault(Belt_Option.flatMap(Caml_js_exceptions.as_js_exn(exn), (function (prim) {
                        return prim.message;
                      })), "could not create a regular expression from string '" + str + "'")
          };
  }
}

function splitByRegex(str, regex) {
  return str.split(regex).map(function (strOpt) {
                return Belt_Option.getWithDefault(strOpt, "").trim();
              }).filter(function (str) {
              return str.length > 0;
            });
}

var newLineRegex = /[\n\r]/;

function multilineTextToNonEmptyLines(__x) {
  return splitByRegex(__x, newLineRegex);
}

var whitespaceDelimRegex = /[\s\n\r]/;

function getSpaceSeparatedValuesAsArray(__x) {
  return splitByRegex(__x, whitespaceDelimRegex);
}

var plusSignRegex = /\+/g;

var minusSignRegex = /-/g;

var forwardSlashSignRegex = /\//g;

var underscoreSignRegex = /_/g;

function strToSafeBase64(str) {
  return btoa(str).replace(plusSignRegex, "-").replace(forwardSlashSignRegex, "_");
}

function safeBase64ToStr(safeBase64) {
  return atob(safeBase64.replace(underscoreSignRegex, "/").replace(minusSignRegex, "+"));
}

function versionMake(val) {
  return {
          ver: 0,
          val: val
        };
}

function versionSet(version, newVal) {
  return {
          ver: version.ver + 1 | 0,
          val: newVal
        };
}

function strToBase64(prim) {
  return btoa(prim);
}

function base64ToStr(prim) {
  return atob(prim);
}

function $$setTimeout$1(prim0, prim1) {
  return setTimeout(prim0, prim1);
}

function $$clearTimeout$1(prim) {
  clearTimeout(prim);
}

var stubTimeoutId = 0;

exports.nbsp = nbsp;
exports.circleChar = circleChar;
exports.currTimeStr = currTimeStr;
exports.compareDates = compareDates;
exports.floatToPctStr = floatToPctStr;
exports.cacheMake = cacheMake;
exports.cacheGetByDepVer = cacheGetByDepVer;
exports.cacheGet = cacheGet;
exports.multilineTextToNonEmptyLines = multilineTextToNonEmptyLines;
exports.getSpaceSeparatedValuesAsArray = getSpaceSeparatedValuesAsArray;
exports.strToBase64 = strToBase64;
exports.base64ToStr = base64ToStr;
exports.strToSafeBase64 = strToSafeBase64;
exports.safeBase64ToStr = safeBase64ToStr;
exports.strToRegex = strToRegex;
exports.$$setTimeout = $$setTimeout$1;
exports.$$clearTimeout = $$clearTimeout$1;
exports.stubTimeoutId = stubTimeoutId;
exports.versionMake = versionMake;
exports.versionSet = versionSet;
/* nbsp Not a pure module */
